import { BrowserService } from "src/services";
import { Android } from "./android";
import { IOS } from "./ios";

export const AddToHomeScreen: React.FC = () => {
    return (
        <>
            {BrowserService.isIOS && BrowserService.isSafari && <IOS />}
            {(!BrowserService.isIOS || !BrowserService.isSafari) && <Android />}
        </>
    );
};